interface DocumentBranding {
  appName: string
  faviconUrl: string | null
}

/** Apply runtime branding that lives outside React (tab title + favicon). */
export function applyDocumentBranding(cfg: DocumentBranding): void {
  if (cfg.appName) document.title = cfg.appName
  if (cfg.faviconUrl) {
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = cfg.faviconUrl
  }
}
